import React, { useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import calender from '@ingka/ssr-icon/paths/calendar';
import chevronLeftSmall from '@ingka/ssr-icon/paths/chevron-left-small';
import SSRIcon from '@ingka/ssr-icon';
import './datePickerComponent.scss';

interface DatePickerComponentProps {
  heading: string;
  selectedDate: Date | null;
  onChange: (formattedDate: string | null) => void;
  format?: 'iso' | 'date';
}

const DatePickerComponent: React.FC<DatePickerComponentProps> = ({
  heading,
  selectedDate,
  onChange,
  format = 'iso',
}) => {
  const handleDateChange = (date: Date | null) => {
    if (date) {
      const formatted =
        format === 'date'
          ? date.toISOString().split('T')[0] // 'YYYY-MM-DD'
          : date.toISOString(); // full ISO
      onChange(formatted);
    } else {
      onChange(null);
    }
  };

  return (
    <>
      <span>{heading}</span>
      <div className="input-field">
        <DatePicker
          selected={selectedDate}
          onChange={handleDateChange}
          placeholderText="yyyy-mm-dd"
          dateFormat="yyyy-MM-dd"
          className="date-picker-global"
          // popperPlacement="left"
        />
      </div>
    </>
  );
};

export default DatePickerComponent;
